const LOAD_CURRENT_MERCHANT_INFO = 'LoadCurrentMerchantInfo';
const LOAD_MANAGE_MERCHANTS = 'LoadManageMerchants';
const CHANGE_CURRENT_MERCHANT = 'ChangeCurrentMerchant';
const SUB_MCH_STATE_QUERY = 'SubMchStateQuery';
const WX_SUB_MCH_APPLY = 'WxSubMchApply';
const REFRESH_TOKEN = 'RefreshToken';
const LOAD_CONFIG = 'LoadConfig';
const ADD_ORDER_EXPORT_ONCE_TASK = 'AddOrderExportOnceTask';
const ADD_ORDER_EXPORT_REPEAT_TASK = 'AddOrderExportRepeatTask';
const LOAD_ORDER_EXPORT_TASKS = 'LoadOrderExportTasks';

const LOGIN = 'Login';
const LOAD_AUTH_URL = 'LoadAuthUrl';

const ApiServices = {};
//获取商户信息
ApiServices[LOAD_CURRENT_MERCHANT_INFO] = {
    apiName: 'get-current-merchant',
    method: 'get',
    url: 'api/v1/merchant-center-service/auth/merchant/get-current-merchant'
};
//获取（管理员）所管理的商户列表
ApiServices[LOAD_MANAGE_MERCHANTS] = {
    apiName: 'get-manage-merchants',
    method: 'get',
    url: 'api/v1/merchant-center-service/auth/merchant/get-manage-merchants'
};

ApiServices[CHANGE_CURRENT_MERCHANT] = {
    apiName: 'change-merchant',
    method: 'put',
    url: 'api/v1/merchant-center-service/auth/merchant/change-merchant'
};

ApiServices[SUB_MCH_STATE_QUERY] = {
    apiName: 'wx-merchant-query',
    method: 'get',
    url: 'api/v1/merchant-center-service/auth/merchant/account/sub-mch/applyment/query'
};

ApiServices[WX_SUB_MCH_APPLY] = {
    apiName: 'wx-merchant-apply',
    method: 'post',
    url: 'api/v1/merchant-center-service/auth/merchant/account/sub-mch/apply'
};

ApiServices[REFRESH_TOKEN] = {
    apiName: 'refresh-token',
    method: 'post',
    url: 'api/v1/auth-center-service/auth/refresh-token'
};

ApiServices[LOAD_CONFIG] = {
    apiName: 'get-wx-auth-config',
    method: 'get',
    url: 'api/v1/auth-center-service/auth/web-auth/get-wx-auth-config'
};//获取微信授权登陆信息
ApiServices[LOAD_AUTH_URL] = {
    apiName: 'get-wx-auth-url',
    method: 'get',
    url: 'api/v1/auth-center-service/auth/web-auth/get-wx-auth-url'
};//获取微信授权登录URL二维码地址

ApiServices[LOGIN] = {apiName: 'login', method: 'post', url: '/api/login'};//登录接口

ApiServices[ADD_ORDER_EXPORT_ONCE_TASK] = {
    apiName: 'add-order-export-once-task',
    method: 'post',
    url: 'api/v1/task-center-service/auth/add/order-export-once-task'
};

ApiServices[ADD_ORDER_EXPORT_REPEAT_TASK] = {
    apiName: 'add-order-export-repeat-task',
    method: 'post',
    url: 'api/v1/task-center-service/auth/add/order-export-repeat-task'
};

ApiServices[LOAD_ORDER_EXPORT_TASKS] = {
    apiName: 'load-order-export-tasks',
    method: 'get',
    url: 'api/v1/task-center-service/auth/get/order-export-tasks'
};

export default ApiServices;
export {
    LOAD_CURRENT_MERCHANT_INFO,
    LOAD_MANAGE_MERCHANTS,
    CHANGE_CURRENT_MERCHANT,
    SUB_MCH_STATE_QUERY,
    WX_SUB_MCH_APPLY,
    REFRESH_TOKEN,
    LOAD_CONFIG,
    LOAD_AUTH_URL,
    LOGIN,
    ADD_ORDER_EXPORT_ONCE_TASK,
    ADD_ORDER_EXPORT_REPEAT_TASK,
    LOAD_ORDER_EXPORT_TASKS,
};
